<app-header class="sticky top-header auto-fma" [pageName]="'appPage'"></app-header>
<div class="main-container bg-white landingPage-links sticky top-tabs-container">
  <div class="container">
    <div class="row">
      <div class="col d-flex">
        <ul class="d-flex">
          <li [ngClass]="selectedTab?.id === 'tab1' ? 'active' : ''">
            <a (click)="toggleTab('tab1')">{{ 'lang.appShared.faqComponent.cIAPOverview' | translate }}</a>
          </li>
          <li [ngClass]="selectedTab?.id === 'tab2' ? 'active' : ''">
            <a (click)="toggleTab('tab2')">{{ 'lang.appShared.faqComponent.cIAPQueries' | translate }}</a>
          </li>
          <li [ngClass]="selectedTab?.id === 'tab3' ? 'active' : ''">
            <a (click)="toggleTab('tab3')">{{ 'lang.appShared.faqComponent.technicalFAQs' | translate }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="clearfix"></div>
<div class="sub-container">
  <div class="container">
    <div class="row">
      <div class="col d-flex">
        <div class="bg-white p-4">
          <div id="tab1" [ngClass]="selectedTab?.id === 'tab1' ? '' : 'hide'" *ngIf="selectedTab?.id === 'tab1'">
            <p>
              {{ 'lang.appShared.faqComponent.capgeminiIntelligentAutomation' | translate }}
            </p>
            <p>
              {{ 'lang.appShared.faqComponent.ciapLeveragesMultiple' | translate }}
            </p>
            <div class="d-flex justify-content-center">
              <img src="{{ 'lang.appShared.faqComponent.faqImage1' | translate }}.png" alt="" />
            </div>
          </div>
          <div id="tab2" [ngClass]="selectedTab?.id === 'tab2' ? '' : 'hide'" *ngIf="selectedTab?.id === 'tab2'">
            <p>
              {{ 'lang.appShared.faqComponent.belowIsACompilation' | translate }}
            </p>
            <div class="clearfix">
              <h5>{{ 'lang.appShared.faqComponent.webinarFaqs' | translate }}</h5>
              <blocx-accordion>
                <div *ngFor="let item of fistDataArr">
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ item.ques | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <div>
                        <p>
                          {{ item.ans | translate }}
                        </p>
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>
              </blocx-accordion>
            </div>
            <div class="clearfix">
              <h5 class="top-spacing">{{ 'lang.appShared.faqComponent.europeSBUFAQs' | translate }}</h5>
              <p>{{ 'lang.appShared.faqComponent.aboutTheBlockersIdentified' | translate }}</p>
              <blocx-accordion>
                <div *ngFor="let item of secondDataArr">
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ item.ques | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <div>
                        <ul>
                          <li *ngFor="let itemAns of item.ans" [ngClass]="item.ans.length === 1 ? 'no-style' : ''">
                            {{ itemAns | translate }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>

                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.logsOfApplications' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <div>
                        <ul>
                          <li>
                            {{ 'lang.appShared.faqComponent.ifCustomerHasFull' | translate }}
                            <ol>
                              <li>{{ 'lang.appShared.faqComponent.configFileChanges' | translate }}</li>
                              <li>{{ 'lang.appShared.faqComponent.enablePortNetwork' | translate }}</li>
                            </ol>
                          </li>
                          <li>
                            {{ 'lang.appShared.faqComponent.customerHasAccess' | translate }}
                            <ol>
                              <li>{{ 'lang.appShared.faqComponent.mapInformationToCIAP' | translate }}</li>
                              <li>{{ 'lang.appShared.faqComponent.createACommonFormat' | translate }}</li>
                              <li>{{ 'lang.appShared.faqComponent.fileImportOfEvent' | translate }}</li>
                            </ol>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>

                <div *ngFor="let item of thridDataArr">
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ item.ques | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <div>
                        <ul>
                          <li *ngFor="let itemAns of item.ans" [ngClass]="item.ans.length === 1 ? 'no-style' : ''">
                            {{ itemAns | translate }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>
              </blocx-accordion>
            </div>
          </div>

          <div id="tab3" [ngClass]="selectedTab?.id === 'tab3' ? '' : 'hide'" *ngIf="selectedTab?.id === 'tab3'">
            <h5>{{ 'lang.appShared.faqComponent.implementationOfSecurity' | translate }}</h5>
            <div class="clearfix">
              <blocx-accordion>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.levelsOfSecurity' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <div>
                        <div>
                          <p>{{ 'lang.appShared.faqComponent.securityForCIAP' | translate }}</p>
                          <ul>
                            <li>
                              {{ 'lang.appShared.faqComponent.perimeterSecurity' | translate }}
                              <ol>
                                <li>
                                  {{ 'lang.appShared.faqComponent.firewallIDSIPS' | translate }}
                                </li>
                              </ol>
                            </li>
                            <li>
                              {{ 'lang.appShared.faqComponent.networkSecurity' | translate }}
                              <ol>
                                <li>
                                  {{ 'lang.appShared.faqComponent.virtualPrivateCloud' | translate }}
                                </li>
                              </ol>
                            </li>
                            <li>
                              {{ 'lang.appShared.faqComponent.applicationSecurity' | translate }}
                              <ol>
                                <li>
                                  {{ 'lang.appShared.faqComponent.wAFAPISecurity' | translate }}
                                </li>
                              </ol>
                            </li>
                            <li>
                              {{ 'lang.appShared.faqComponent.identityAndAccessManagement' | translate }}
                              <ol>
                                <li>{{ 'lang.appShared.faqComponent.identityFederation' | translate }}</li>
                              </ol>
                            </li>
                            <li>
                              {{ 'lang.appShared.faqComponent.dataSecurity' | translate }}
                              <ol>
                                <li>
                                  {{ 'lang.appShared.faqComponent.accessManagement' | translate }}
                                </li>
                              </ol>
                            </li>
                            <li>
                              {{ 'lang.appShared.faqComponent.loggingAndSecurity' | translate }}
                              <ol>
                                <li>{{ 'lang.appShared.faqComponent.aWSCloudWatch' | translate }}</li>
                              </ol>
                            </li>
                            <li>
                              {{ 'lang.appShared.faqComponent.vulnerabilityAndScanning' | translate }}
                              <ol>
                                <li>{{ 'lang.appShared.faqComponent.aWSInspector' | translate }}</li>
                              </ol>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.howIsPerimeterSecurity' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <div>
                        <p>
                          <b>{{ 'lang.appShared.faqComponent.fortinetNextGenerationFirewall' | translate }}</b>
                          {{ 'lang.appShared.faqComponent.isAKeyComponentFor' | translate }}
                        </p>
                        <div class="d-flex justify-content-center">
                          <img src="/assets/images/faq_img_2.png" alt="" />
                        </div>
                        <p>
                          {{ 'lang.appShared.faqComponent.keyFeaturesOfThisSolution' | translate }}
                        </p>
                        <ul>
                          <li>{{ 'lang.appShared.faqComponent.highPerformanceThreat' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.networkProtection' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.iPSTechnologyProtects' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.anomalyBasedDetection' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.dockerApplicationControl' | translate }}</li>
                        </ul>
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.howIsWebSecurity' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <div>
                        <p>
                          <b>{{ 'lang.appShared.faqComponent.webApplicationsFirewall' | translate }}</b>
                          {{ 'lang.appShared.faqComponent.isDeployedToProtect' | translate }}
                        </p>
                        <div class="d-flex justify-content-center">
                          <img src="/assets/images/faq_img_3.png" alt="" />
                        </div>
                        <p>
                          {{ 'lang.appShared.faqComponent.keyFeaturesOfThisSolution' | translate }}
                        </p>
                        <ul>
                          <li>{{ 'lang.appShared.faqComponent.abilityToDefineCustomized' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.preventApplication' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.preventSQLInjection' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.badBotsProtection' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.increasedProtection' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.improvedWebTraffic' | translate }}</li>
                          <li>{{ 'lang.appShared.faqComponent.iPReputationList' | translate }}</li>
                        </ul>
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.howIsApplications' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <p>
                        {{ 'lang.appShared.faqComponent.applicationSecurityIsImplemented' | translate }}
                        <b>{{ 'lang.appShared.faqComponent.wSO2APIManager' | translate }}</b>
                        {{ 'lang.appShared.faqComponent.completeEnterpriseClass' | translate }}
                      </p>
                      <div class="d-flex justify-content-center">
                        <img src="/assets/images/faq_img_4.png" alt="" />
                      </div>

                      <p>{{ 'lang.appShared.faqComponent.thisSolutionInclude' | translate }}</p>
                      <ul>
                        <li>{{ 'lang.appShared.faqComponent.abilityToRestrict' | translate }}</li>
                        <li>{{ 'lang.appShared.faqComponent.applyAdditionalSecurity' | translate }}</li>
                        <li>{{ 'lang.appShared.faqComponent.threatProtectionBotDetection' | translate }}</li>
                        <li>{{ 'lang.appShared.faqComponent.supportsDetectionOfAbnormal' | translate }}</li>
                        <li>{{ 'lang.appShared.faqComponent.validateAPIsPayload' | translate }}</li>
                      </ul>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.howAreTheCredentialManagement' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <p>{{ 'lang.appShared.faqComponent.thereAreSpecificCredential' | translate }}</p>
                      <ul>
                        <li>
                          {{ 'lang.appShared.faqComponent.secureVaultUsed' | translate }}
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.orchestratorAssetOrCredential' | translate }}
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.credentialStoreUsed' | translate }}
                        </li>
                      </ul>
                      <p>{{ 'lang.appShared.faqComponent.apartFromThisApplications' | translate }}</p>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          <p>{{ 'lang.appShared.faqComponent.howAreAPISecured' | translate }}</p>
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <p>{{ 'lang.appShared.faqComponent.allTheAPIsAreAuthenticated' | translate }}</p>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.howIsSecurityImplemented' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <p>{{ 'lang.appShared.faqComponent.networkSecurityIsManaged' | translate }}</p>
                      <ul>
                        <li>
                          {{ 'lang.appShared.faqComponent.awsVPC' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.itsYourPrivate' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.virtualBoundary' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.firstLineOfSecurity' | translate }}</li>
                          </ol>
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.networkACLs' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.intraCIDR' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.worksBetween' | translate }}</li>
                          </ol>
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.transitGateway' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.intraCIDR' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.worksBetween' | translate }}</li>
                          </ol>
                        </li>
                      </ul>
                      <p>{{ 'lang.appShared.faqComponent.instanceSecurity' | translate }}</p>
                      <ul>
                        <li>
                          {{ 'lang.appShared.faqComponent.securityGroups' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.attachedToAWS' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.worksAsAFirewall' | translate }}</li>
                          </ol>
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.endPointProtection' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.symantecProtection' | translate }}</li>
                          </ol>
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.vulnerabilityScanning' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.awsInspectorDocker' | translate }}</li>
                          </ol>
                        </li>
                      </ul>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.howIsDataSecurity' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <p>{{ 'lang.appShared.faqComponent.dataSecurityIsImplemented' | translate }}</p>
                      <ul>
                        <li>
                          {{ 'lang.appShared.faqComponent.dataAtRest' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.diskAndDBLevel' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.KeyVaultAndCertificate' | translate }}</li>
                          </ol>
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.dataInTransit' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.iPSecForVPNConnections' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.bitEncryption' | translate }}</li>
                          </ol>
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.dataBackupAndRecovery' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.n2WSCloudProtection' | translate }}</li>
                          </ol>
                        </li>
                      </ul>
                      <div class="d-flex justify-content-center">
                        <img src="/assets/images/faq_img_5.png" alt="" />
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.whichEncryptionServices' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      {{ 'lang.appShared.faqComponent.awsKmsServices' | translate }}
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.howIsUserLevel' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <p>{{ 'lang.appShared.faqComponent.userLevelSecurity' | translate }}</p>
                      <ul>
                        <li>
                          {{ 'lang.appShared.faqComponent.iAM' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.adDomainServices' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.directoryFederation' | translate }}</li>
                          </ol>
                        </li>
                        <li>
                          {{ 'lang.appShared.faqComponent.mfa' | translate }}
                          <ol>
                            <li>{{ 'lang.appShared.faqComponent.nativeMultiFactor' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.secondFactorAuthentication' | translate }}</li>
                            <li>{{ 'lang.appShared.faqComponent.mfaForCertainComponents' | translate }}</li>
                          </ol>
                        </li>
                      </ul>
                      <p>{{ 'lang.appShared.faqComponent.theDeploymentModel' | translate }}</p>

                      <div class="d-flex justify-content-center">
                        <img src="/assets/images/faq_img_6.png" alt="" />
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.whatIsTheAntivirus' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <p>{{ 'lang.appShared.faqComponent.cIAPUsesSymantecEndpoint' | translate }}</p>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div>
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ 'lang.appShared.faqComponent.howIsTheConnectivity' | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <p>{{ 'lang.appShared.faqComponent.forDedicatedConnectivity' | translate }}</p>
                      <ul>
                        <li>{{ 'lang.appShared.faqComponent.siteToSiteVPNConnection' | translate }}</li>
                        <li>{{ 'lang.appShared.faqComponent.awsDirectConnect' | translate }}</li>
                      </ul>
                      <p>{{ 'lang.appShared.faqComponent.fortinetFirewallManages' | translate }}</p>
                      <ul>
                        <li>{{ 'lang.appShared.faqComponent.deployedInCIAP' | translate }}</li>
                        <li>{{ 'lang.appShared.faqComponent.configuredWithAllMandatory' | translate }}</li>
                      </ul>
                    </div>
                  </blocx-accordion-item>
                </div>
                <div *ngFor="let item of technicalFaq">
                  <blocx-accordion-item
                    [accordionIconClass]="'blocx-accordion_icon'"
                    [accordionTitleIconImg]="'assets/images/blocx-accordion_icon-right-arrow-default.svg'"
                  >
                    <ng-container title-placeholder>
                      <div class="d-flex">
                        <span class="acordion-title mr-auto">
                          {{ item.ques | translate }}
                        </span>
                      </div>
                    </ng-container>
                    <div class="blocx-accordion_body">
                      <div>
                        <p>
                          {{ item.ans | translate }}
                        </p>
                      </div>
                    </div>
                  </blocx-accordion-item>
                </div>
              </blocx-accordion>
            </div>
            <div class="clearfix">
              <blocx-accordion></blocx-accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="back-button vert-move"
  (click)="navigateBack()"
  cdkDrag
  (cdkDragStarted)="handleDragStart('back-button', $event)"
>
  <span class="icon-Go-back"></span>
  {{ 'lang.commonComponents.backButtonNavigation.goBack' | translate }}
</div>
